import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header", "destination"]

  connect() {
    this.handleHashChange = () => this.focusCurrentDestination()
    this.resizeObserver = new ResizeObserver(() => this.updateHeaderHeight())

    if (this.hasHeaderTarget) {
      this.resizeObserver.observe(this.headerTarget)
    }

    window.addEventListener("hashchange", this.handleHashChange)
    this.updateHeaderHeight()
    this.animationFrame = requestAnimationFrame(() => this.focusCurrentDestination())
  }

  disconnect() {
    window.removeEventListener("hashchange", this.handleHashChange)
    this.resizeObserver.disconnect()
    cancelAnimationFrame(this.animationFrame)
  }

  updateHeaderHeight() {
    if (!this.hasHeaderTarget) return

    const height = Math.ceil(this.headerTarget.getBoundingClientRect().height)
    document.documentElement.style.setProperty("--sticky-header-height", `${height}px`)
  }

  focusCurrentDestination() {
    const fragmentId = this.currentFragmentId()
    if (!fragmentId) return

    const destination = this.destinationTargets.find((element) => element.id === fragmentId)
    if (!destination) return

    this.updateHeaderHeight()
    destination.scrollIntoView({ block: "start" })
    destination.focus({ preventScroll: true })
  }

  currentFragmentId() {
    if (window.location.hash.length < 2) return null

    try {
      return decodeURIComponent(window.location.hash.slice(1))
    } catch (_error) {
      return null
    }
  }
}
